import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductoActividad } from '../../../_models/producto-actividad';
import { ProductoActividadCampoService } from '../../../_services/producto-actividad-campo.service';
import { ProductoActividadCampo } from '../../../_models/producto-actividad-campo';

@Component( {
  selector: 'app-producto-actividad-aliado-detalle',
  templateUrl: 'producto-actividad-aliado-detalle.component.html'
} )

export class ProductoActividadAliadoDetalleComponent implements OnInit {

  @Input() proActividad: ProductoActividad;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  lisProductoActividadCampo: ProductoActividadCampo[] = [];
  carTabla = true;
  iterador: number[] = [];

  constructor( private proActividadCampoServicio: ProductoActividadCampoService ) {
  }

  ngOnInit(): void {
    this.iterador.push( 0 );
    this.iterador.push( 1 );
    this.iterador.push( 2 );
    this.proActividadCampoServicio.listadoPorProductoActividad(this.proActividad.idProductoSegmento).subscribe( listado => {
      this.lisProductoActividadCampo = listado.filter(x => x.indicadorHabilitado);
      this.carTabla = false;
    } );
  }

  regresar() {
    this.dismiss.emit( false );
  }
}
